import React from 'react'

export const Fabrics = () => {
  return (
    <div>Fabrics</div>
  )
}
